import request from '@/utils/request'

// 部门管理API

// 获取部门树
export function getDepartmentTree(tenantId) {
  return request({
    url: '/api/admin/departments/tree',
    method: 'get',
    params: { tenantId }
  })
}

// 获取部门列表
export function listDepartments(params) {
  return request({
    url: '/api/admin/departments',
    method: 'get',
    params
  })
}

// 获取部门详情
export function getDepartment(departmentId) {
  return request({
    url: `/api/admin/departments/${departmentId}`,
    method: 'get'
  })
}

// 创建部门
export function createDepartment(data) {
  return request({
    url: '/api/admin/departments',
    method: 'post',
    data
  })
}

// 更新部门
export function updateDepartment(departmentId, data) {
  return request({
    url: `/api/admin/departments/${departmentId}`,
    method: 'put',
    data
  })
}

// 删除部门
export function deleteDepartment(departmentId) {
  return request({
    url: `/api/admin/departments/${departmentId}`,
    method: 'delete'
  })
}

// 获取部门下的客服列表
export function getDepartmentAgents(departmentId) {
  return request({
    url: `/api/admin/departments/${departmentId}/agents`,
    method: 'get'
  })
}

// 更新部门业务类型
export function updateDepartmentBusinessKeys(departmentId, businessKeys) {
  return request({
    url: `/api/admin/departments/${departmentId}/business-keys`,
    method: 'put',
    data: businessKeys
  })
}

// 更新部门优先级
export function updateDepartmentPriority(departmentId, priority) {
  return request({
    url: `/api/admin/departments/${departmentId}/priority`,
    method: 'put',
    params: { priority }
  })
}

// 启用/禁用部门
export function updateDepartmentActiveStatus(departmentId, isActive) {
  return request({
    url: `/api/admin/departments/${departmentId}/active-status`,
    method: 'put',
    params: { isActive }
  })
}
